import { Reveal, SectionHeading } from "@/components/site/Reveal";
import { POSITIONING_TAGS, COMPLIANCE_NOTE } from "@/data/content";
import { ShieldCheck } from "lucide-react";

export default function Positioning() {
  return (
    <section id="positioning" className="relative py-16 lg:py-24 bg-[#04121f]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap items-center gap-3">
          {POSITIONING_TAGS.map((t, i) => (
            <span key={t} className="inline-flex items-center gap-2 rounded-full border border-cyan-400/25 bg-cyan-950/30 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.2em] text-cyan-200">
              {i > 0 && <span className="text-cyan-500/60">•</span>}{t}
            </span>
          ))}
        </div>
        <Reveal>
          <SectionHeading number="01" eyebrow="Company Positioning" title="An Indian aquaculture & food-products company, building export."
            subtitle="AquaFionix is an Indian aquaculture and food products company focused on responsible production, sourcing, quality and market access. Our current international trade focus is Makhana (Fox Nuts), with RAS-assisted, high-tech shrimp and crab farming — planned around a zero-waste approach — developed as a future export vertical." />
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-8 flex items-start gap-4 rounded-2xl glass p-5 max-w-3xl">
            <ShieldCheck className="h-5 w-5 mt-0.5 text-emerald-400 shrink-0" />
            <p className="text-sm text-slate-300 leading-relaxed"><span className="font-semibold text-white">Quality &amp; Export Compliance — </span>{COMPLIANCE_NOTE}</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
